import React, { useState, useEffect } from 'react'

import { toast } from 'react-toastify'

import FileIcon from 'presentation/assets/icons/file-icon.svg'
import { ReactComponent as ViewIcon } from 'presentation/assets/icons/eye-dark-gray.svg'
import FileViewer from 'presentation/shared/components/FileViewer'
import { useServices } from 'presentation/hooks/use-services'
import LoadingModal from 'presentation/shared/components/LoadingModal'
import { Document } from 'domain/entities/document'

import * as S from './styles'

type DocumentCardProps = {
  document: Document
  doctor_id: number
}

const DocumentCard = ({ document, doctor_id }: DocumentCardProps) => {
  const [showFilePreview, setShowFilePreview] = useState(false)
  const [documentFile, setDocumentFile] = useState<
    { fileUrl: string; contentType: string } | undefined
  >()
  const [showLoadingModal, setShowLoadingModal] = useState(false)

  const doctorService = useServices().doctor

  const handleViewDocument = async () => {
    try {
      if (document.documentUri && doctor_id && document.document_id) {
        setShowLoadingModal(true)
        const doctorDocument = await doctorService.loadDoctorDocument({
          doctor_id: doctor_id,
          document_id: document.document_id
        })
        if (doctorDocument) {
          setDocumentFile({
            fileUrl: URL.createObjectURL(doctorDocument.data),
            contentType: doctorDocument.data.type
          })
        }
      }
    } catch (e) {
      toast.error('Falha ao visualizar o documento.')
    } finally {
      setShowLoadingModal(false)
    }
  }

  useEffect(() => {
    if (documentFile) {
      setShowFilePreview(true)
    }
  }, [documentFile])

  const formatDate = (date: string | Date | undefined) => {
    if (!date) return '--'

    const dateFormatted = new Date(date)
    return `${dateFormatted.getDate()}/${
      dateFormatted.getMonth() + 1
    }/${dateFormatted.getFullYear()}`
  }

  return (
    <S.Wrapper>
      <S.File>
        <S.FileIcon src={FileIcon} />
        <S.FileName>{document.name}</S.FileName>
      </S.File>
      {!!document.conclusionDate && (
        <S.UploadAt>
          Data da Emissão: {formatDate(document.conclusionDate)}
        </S.UploadAt>
      )}
      <S.UploadAt>Upload feito em {formatDate(document.updatedAt)}</S.UploadAt>
      <S.ActionButtons>
        <button onClick={() => handleViewDocument()}>
          <ViewIcon />
          <label>Visualizar</label>
        </button>
      </S.ActionButtons>
      {documentFile && showFilePreview && (
        <FileViewer
          file={{
            fileUrl: documentFile.fileUrl,
            contentType: documentFile.contentType
          }}
          show={showFilePreview}
          onClose={() => setShowFilePreview(false)}
        />
      )}
      <LoadingModal show={showLoadingModal} />
    </S.Wrapper>
  )
}

export default DocumentCard
